module.exports = __webpack_public_path__ + "img/55200.18fea0da.jpg";